import { ActionListOption } from '~/components/DataTables/components/ActionColumnCell';
import { TableHeaderDefinitionCellType } from '../../types.flow';

import cleanedFilename from '~/util/cleanedFilename';

export const ACTION_COLUMN_ACCESSOR = 'action-column';
type ActionHeaderCellOptions = {
  dataTestid?: string;
  minWidth?: number;
};
const ACTION_COLUMN_WIDTH = 20;
const asActionTableHeaderCell = ({
  dataTestid,
  minWidth,
}: ActionHeaderCellOptions): TableHeaderDefinitionCellType<
  Array<ActionListOption>
> => ({
  Cell: () => {
    throw Error(
      `${cleanedFilename(
        __filename,
      )} Should not occur! Action rendering should be handled by the table`,
    );
  },
  Header: '',
  accessor: ACTION_COLUMN_ACCESSOR,
  dataTestid,
  disableResizing: true,
  disableSortBy: true,
  minWidth: minWidth || ACTION_COLUMN_WIDTH,
  maxWidth: ACTION_COLUMN_WIDTH,
  width: ACTION_COLUMN_WIDTH,
  hideTooltip: true,
});

export default asActionTableHeaderCell;
